import React from 'react';
import { Resizable } from 'react-resizable';

export default function VZ__Resizable(props: any) {
    const { onResize, width, ...restProps } = props;
    const numericWidth = Number(width);
    if (!numericWidth ) {
        return <th {...restProps} />;
    }

    return (
        <Resizable
            width={numericWidth}
            height={0}
            handle={
                <span
                    className="react-resizable-handle"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                />
            }
            onResize={onResize}
            draggableOpts={{ enableUserSelectHack: false }}
        >
            <th {...restProps} />
        </Resizable>
    );
}
